import React, { useEffect, useState } from "react";
import PageHero, { usePageMeta } from "@/components/marketing/PageHero";
import { Star, MessageSquareQuote } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import api from "@/lib/api";

export default function Recensioni() {
  const { lang } = useI18n();
  const L = (it, en, de) => (lang === "en" ? en : lang === "de" ? (de ?? it) : it);
  usePageMeta(L("Recensioni", "Reviews", "Bewertungen"), L("Testimonianze verificate dei clienti di Recovers Crypto.", "Verified testimonials from Recovers Crypto clients.", "Verifizierte Erfahrungsberichte von Recovers-Crypto-Kunden."));
  const [reviews, setReviews] = useState([]);
  useEffect(() => { api.get("/content/reviews").then(({ data }) => setReviews(data)).catch(() => {}); }, []);
  return (
    <div>
      <PageHero eyebrow={L("Recensioni", "Reviews", "Bewertungen")} title={L("Testimonianze verificate", "Verified testimonials", "Verifizierte Erfahrungsberichte")}
        subtitle={L("Pubblichiamo solo testimonianze verificate e approvate. Non generiamo recensioni, valutazioni o storie fittizie.", "We publish only verified and approved testimonials. We do not generate fake reviews, ratings or stories.", "Wir veröffentlichen nur verifizierte und freigegebene Erfahrungsberichte. Wir erzeugen keine erfundenen Bewertungen, Ratings oder Geschichten.")} />
      <section className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-20">
        {reviews.length === 0 ? (
          <div className="rounded-xl border border-dashed border-white/15 bg-navy-paper p-12 text-center" data-testid="reviews-empty">
            <MessageSquareQuote className="mx-auto h-8 w-8 text-slate-600" />
            <p className="mt-3 text-sm text-slate-400">{L("Nessuna testimonianza pubblicata al momento.", "No testimonials published at the moment.", "Derzeit keine Erfahrungsberichte veröffentlicht.")}</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {reviews.map((r) => (
              <div key={r.id} className="rounded-xl border border-white/10 bg-navy-paper p-6">
                <div className="flex gap-0.5 text-gold">
                  {Array.from({ length: r.rating || 5 }).map((_, i) => <Star key={i} className="h-4 w-4 fill-gold" />)}
                </div>
                <p className="mt-3 text-sm text-slate-300 leading-relaxed">"{r.body}"</p>
                <p className="mt-4 text-xs text-slate-500">— {r.author_label}</p>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
